// Indicator options sourced from web/public/schemas/customlogs_v0_schema.json
// This is the canonical list of valid indicator scanner names for schema fields.

import customLogsSchema from 'Public/schemas/customlogs_v0_schema.json';

export interface IndicatorOption {
  value: string;
  label: string;
}

const toLabel = (value: string): string =>
  value
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

// Custom labels for indicators where toLabel doesn't produce the right result
const CUSTOM_LABELS: Record<string, string> = {
  ip: 'IP Address',
  md5: 'MD5 Hash',
  sha1: 'SHA1 Hash',
  sha256: 'SHA256 Hash',
  url: 'URL',
  aws_arn: 'AWS ARN',
  aws_account_id: 'AWS Account ID',
  aws_instance_id: 'AWS Instance ID',
  aws_tag: 'AWS Tag',
  mac: 'MAC Address',
  cve: 'CVE',
  mitre_attack_technique: 'MITRE ATT&CK Technique',
  actor_id: 'Actor ID',
  domain: 'Domain Name',
};

const indicatorEnum: string[] = (customLogsSchema.definitions?.indicator as any)?.enum ?? [];

export const INDICATOR_OPTIONS: IndicatorOption[] = indicatorEnum.map(value => ({
  value,
  label: CUSTOM_LABELS[value] ?? toLabel(value),
}));

export const indicatorToString = (item: IndicatorOption): string => item.label;

// Types eligible for indicator annotation
export const INDICATOR_ELIGIBLE_TYPES = ['string'];

export const isIndicatorEligible = (type: string): boolean =>
  INDICATOR_ELIGIBLE_TYPES.includes(type);

// O(1) lookup map built once at module scope
export const INDICATOR_OPTIONS_MAP = new Map(INDICATOR_OPTIONS.map(o => [o.value, o]));

// Look up display label for a stored indicator value
export const getIndicatorLabel = (value: string): string =>
  INDICATOR_OPTIONS_MAP.get(value)?.label ?? toLabel(value);
